import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";
export const AddCommercial_Api = async (data) => {
  try {
    let response = await _axios.post(`${END_POINTS.ADD_COMMERCIAL}`, data);
    console.log("response in get places", response);
    return response?.data?.data;
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getAllCommercial_Api = async () => {
  try {
    let response = await _axios.get(`${END_POINTS.GET_ALL_COMMERCIAL}`);
    console.log("response in get places", response);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getAllUserCommercial_Api = async () => {
  try {
    let response = await _axios.get(`${END_POINTS.USER_ALL_COMMERCIAL}`);
    console.log("response in user get places", response);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getPopularCommercial_Api = async () => {
  try {
    let response = await _axios.get(`${END_POINTS.GET_POPULAR_COMMERCIAL}`);
    console.log("Response of Popular Commercial", response);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};

export const getNearYouCommercial_Api = async ({ lat, lng, radius }) => {
  try {
    let response = await _axios.get(END_POINTS.Get_Near_Commercial, {
      params: {
        lat,
        lng,
        radius,
      },
    });
    console.log("Near You Commerical_api", response);
    return {
      success: true,
      data: response?.data?.data,
    };
  } catch (e) {
    console.log("error in get places", e);
    let errorMessage =
      e?.response?.data?.errors[0]?.message ||
      e?.response?.data?.message ||
      "Something went wrong";
    toast.error(errorMessage);
  }
};
